// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"lock-text__visuallyhidden--i7A7B","focusable":"lock-text__focusable--Dhsl5","tooltip":"lock-text__tooltip--evIFs"};